import { AddButton } from '@gripp/shared-ui';
import { useNavigate, useParams } from 'react-router-dom';
import { useAssetRouting } from '../../../assets/assetRouteContext';

type NewAlertHeaderActionProps = {
  /**
   * Runs before navigation. Use to drive a slide transition (e.g.
   * `slideLayout.onSlideChange(SlideAction.NEXT)`) before pushing the new-alert
   * route. Awaited so async transitions resolve before the navigation fires.
   */
  onBeforeNavigate?: () => void | Promise<void>;
  accessibilityLabel?: string;
};

export const NewAlertHeaderAction = ({
  onBeforeNavigate,
  accessibilityLabel,
}: NewAlertHeaderActionProps) => {
  const navigate = useNavigate();
  const { assetId = '', routineId = '' } = useParams();
  const { basePath } = useAssetRouting(assetId);

  const handlePress = async () => {
    await onBeforeNavigate?.();
    navigate(`${basePath}/routines/${routineId}/alerts/new`);
  };

  return (
    <AddButton
      variant="header"
      onPress={() => void handlePress()}
      accessibilityLabel={accessibilityLabel}
    />
  );
};
